module.exports = __webpack_public_path__ + "img/MLT.334dd7dc.svg";